<script setup lang="ts">
import type { MessageMessage, QuestionMessage } from '../../types';

defineProps<{
  role: 'user' | 'assistant';
  message: MessageMessage | QuestionMessage;
}>();
</script>
<template>
  <div class="p-3 rounded-lg" :class="[role === 'user' ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-700']">
    {{ message.data.text }}
  </div>
</template>
